import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class AddOnsIntroPanel extends Component {
  constructor (props) {
    super(props);

    this.useTypeAddOns = this.useTypeAddOns.bind(this);
  }

  useTypeAddOns () {
    const { listingUseType } = this.props;
    if ('Production' === listingUseType) {
      return [
        { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.add_item', defaultMessage: 'Onsite manager' }), icon: 'avtechnician' },
        { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.lightning', defaultMessage: 'Lighting equipment' }), icon: 'lightbulb_icon' },
        { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.food', defaultMessage: 'Food and drink' }), icon: 'utensils_plates' },
        { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.camera', defaultMessage: 'Camera equipment' }), icon: 'camera' },
        { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.craft', defaultMessage: 'Craft services' }), icon: 'star' },
        { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.furniture_production', defaultMessage: 'Furniture' }), icon: 'chair' }
      ];
    }
    return [
      { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.a_v_equipment', defaultMessage: 'A/V equipment' }), icon: 'stereo' },
      { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.bar', defaultMessage: 'Bar services' }), icon: 'bar' },
      { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.food_drink', defaultMessage: 'Food and drink' }), icon: 'utensils_plates' },
      { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.staffing', defaultMessage: 'Staffing' }), icon: 'avtechnician' },
      { name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.furniture', defaultMessage: 'Furniture' }), icon: 'chair' }
    ].concat('Event' === listingUseType
      ? [{ name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.entertainment', defaultMessage: 'Entertainment' }), icon: 'piano' }]
      : [{ name: this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.printing', defaultMessage: 'Printing' }), icon: 'printer' }]
    );
  }

  render () {
    const { showAddOnsPanel, closePanel } = this.props;
    const popularAddOns = this.useTypeAddOns();
    return (
      showAddOnsPanel &&
        <div className="add-ons-intro-panel">
          <span className="pull-right ico ico-sm icon-close-sidebar" onClick={closePanel} data-testing-id="close-panel-btn"/>
          <h4>
            <FormattedMessage
              id='inbox.add_ons_intro_panel.what_addons'
              defaultMessage='What are add-ons?'
            />
          </h4>
          <p>
            <FormattedMessage
              id='inbox.add_ons_intro_panel.add_services'
              defaultMessage='Add additional services that guests can book with your space. Each add on will be a separate line item in this booking.'
            />
          </p>
          <h4 className="margin-lg-bottom d-xs-none d-sm-block">
            <FormattedMessage
              id='inbox.add_ons_intro_panel.popular'
              defaultMessage='Popular add-ons'
            />
          </h4>
          <div className="popular-add-ons d-xs-none d-sm-flex">
            {
              map(popularAddOns, (addOn, i) => {
                const iconSrc = `/web-2/assets/images/${addOn.icon}.svg?v=rb`;
                return (
                  <div key={`addOn-${i}`} className="add-on flex middle margin-md-bottom" data-testing-id="popular-add-on-item">
                    <img
                      className="icon margin-lg-right"
                      src={iconSrc}
                      alt={ this.props.intl.formatMessage({ id: 'inbox.add_ons_intro_panel.addon_icon', defaultMessage: 'Add-on Icon' }) }
                    />
                    {addOn.name}
                  </div>
                );
              })
            }
          </div>
        </div>
    );
  }
}

AddOnsIntroPanel.propTypes = {
  listingUseType: PropTypes.string,
  showAddOnsPanel: PropTypes.bool,
  closePanel: PropTypes.func,
  intl: intlShape
};

export default injectIntl(AddOnsIntroPanel);
